import Vue from 'vue';
import VueMq from 'vue-mq';
import { cms, translations } from '@nsftx/games-visualization-sdk/src/utility';
import App from './App';
import store from './store';
import { connection } from './utility';
import mutationTypes from './store/mutationTypes';

Vue.config.productionTip = false;
Vue.use(VueMq, {
  breakpoints: {
    mobile: 640,
    mobileLg: 768,
    desktopSm: 1024,
    desktop: 1280,
    desktopLg: 1366,
    desktopMax: 1920,
  },
});

new Vue({
  store,
  created() {
    if (!store.getters.isStreamPlayer) {
      connection.socketConnect();
      cms.getAppSettings({
        company: store.getters.product.company,
        game: 'virtualdragraces',
        env: store.state.product.environment,
      }).then((response) => {
        store.commit(mutationTypes.SET_CMS_CONFIG, response);
      });
      translations.init(
        store.getters.language,
        store.getters.product.company,
        ['Visuals', 'Games.VDR.Visualization'],
      ).then((response) => {
        store.dispatch('updateTranslations', response);
      });
    }
  },
  render: h => h(App),
}).$mount('#app');
